import React, {Component} from 'react';
import { useParams } from "react-router-dom";
import MemberCardDetails from '../components/details/MemberCardDetails';
import HomeButton from '../components/utils/HomeButton';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
  }
class Details extends Component 
{
    constructor() {
		super();
		this.state = {puuid: null,summonerId: null};
	}
    
    render() {
        if(this.props.params.puuid != null) {
        return (
            <><HomeButton /><div className="w-full grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 gap-8 gap-y-12 px-8 mb-20">
                <MemberCardDetails key={this.props.params.puuid} summonerId={this.props.params.summonerId} puuid={this.props.params.puuid} />
            </div></>
        );
        } else {
            return (
                <div className="w-full grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 gap-8 gap-y-12 px-8 mb-20"></div>
            );
        }
    }
}
export default withParams(Details);